import {toggleSlide} from "./Util";

const initReadmoreText = function() {
	document.addEventListener( 'click', ev => {
		if( ! ev.target.matches( '.en_readmore__control_button' ) ) {
			return;
		}
		ev.preventDefault();
		const readmoreEl = ev.target.closest( '.en_readmore' );
		toggleSlide( readmoreEl.querySelector( '.en_readmore__text_wrapper' ), !readmoreEl.classList.contains( 'is_expanded' ) );
		readmoreEl.classList.toggle( 'is_expanded' );
	} );
}

const initReadmoreTabs = function( scopeEl = document ) {
	const maxHeightTabs = scopeEl.querySelectorAll( '.en_tab__item--max-height' );

	addButton();
	checkIfExpandable();
	window.addEventListener( 'resize', () => checkIfExpandable() );

	function checkIfExpandable() {
		maxHeightTabs.forEach( ( tab ) => {
			tab.classList.toggle( 'is-expandable', parseInt( window.getComputedStyle( tab, null ).getPropertyValue( 'max-height' ) ) < tab.querySelector( '.en_tab__item_inner' ).offsetHeight );
		} );
	}

	function addButton() {
		maxHeightTabs.forEach( ( tab ) => {
			const tabInner = tab.querySelector( '.en_tab__item_inner' );

			let readMore = document.createElement( 'div' );
			readMore.className = 'en_tab__item_read_more';

			let readMoreButton = document.createElement( 'button' );
			readMoreButton.type = 'button';
			readMoreButton.className = 'en_button en_button--style_minimal en_button--shrink en_tab__item_read_more_button';

			let readMoreButtonMore = document.createElement( 'span' );
			readMoreButtonMore.className = 'more';
			readMoreButtonMore.innerHTML = window.StringTranslation.get( 'READ_MORE' );

			let readMoreButtonLess = document.createElement( 'span' );
			readMoreButtonLess.className = 'less';
			readMoreButtonLess.innerHTML = window.StringTranslation.get( 'READ_LESS' );

			readMoreButton.appendChild( readMoreButtonMore );
			readMoreButton.appendChild( readMoreButtonLess );

			readMore.appendChild( readMoreButton );

			tab.appendChild( readMore );

			readMoreButton.addEventListener( 'click', () => {
				tab.classList.toggle( 'is-expanded' );
				tab.style.maxHeight = tab.classList.contains( 'is-expanded' ) ? tabInner.offsetHeight + 'px' : '';
			} );
		} );
	}
}

export {
	initReadmoreText,
	initReadmoreTabs
}
